var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.9121 341.422C113.019 331.842 181.298 323.233 247.756 315.923C272.901 313.273 297.857 308.503 323.092 306.703C348.408 304.993 373.684 305.503 399.09 307.213C416.187 308.513 433.364 310.323 450.191 314.023L450.422 317.393C446.307 318.953 442.173 320.293 438.039 321.563C401.382 332.422 363.473 338.942 325.465 341.842C308.638 342.962 291.741 342.652 274.873 342.622C260.259 342.542 239.117 343.152 224.292 343.522C183.421 344.452 138.615 344.882 97.7937 344.982C83.3791 345.032 67.9234 344.962 53.4788 344.872L47.1423 344.802L46.9121 341.422Z",
    fill: "#010202"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.881 237.246C75.1691 237.246 63.4672 237.246 51.7653 237.246C48.8124 237.246 46.4199 239.666 46.4199 242.656C46.4199 245.646 48.8124 248.066 51.7653 248.066C67.7215 248.066 86.2103 248.186 86.881 248.066C87.1312 248.086 89.6638 248.226 91.2554 246.076C92.847 243.926 92.4566 240.886 91.2554 239.246C89.9741 237.486 87.7519 237.246 86.881 237.246Z",
    fill: "#020203"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M167.552 329.182C215.085 329.182 253.619 290.313 253.619 242.366C253.619 194.419 215.085 155.55 167.552 155.55C120.018 155.55 81.4844 194.419 81.4844 242.366C81.4844 290.313 120.018 329.182 167.552 329.182Z",
    fill: "white",
    stroke: "#030304",
    strokeWidth: 10,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M188.692 284.95C164.813 243.778 179.112 191.065 220.641 167.211C262.169 143.356 315.186 157.381 339.065 198.542C362.944 239.714 348.645 292.428 307.117 316.282C265.589 340.136 212.571 326.112 188.692 284.95Z",
    fill: "url(#paint0_linear_1713_13739)",
    stroke: "#030304",
    strokeWidth: 10,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M360.208 328.222C407.93 328.222 446.616 289.506 446.616 241.746C446.616 193.987 407.93 155.27 360.208 155.27C312.487 155.27 273.801 193.987 273.801 241.746C273.801 289.506 312.487 328.222 360.208 328.222Z",
    fill: "white",
    stroke: "#030304",
    strokeWidth: 10,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M342.3 225.177V258.365M324.281 231.207V252.326M360.318 217.127V266.405M378.336 225.177V258.365M396.354 231.207V252.326",
    stroke: "black",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1713_13739",
    x1: 263.881,
    y1: 327.911,
    x2: 263.881,
    y2: 155.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4153A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1922,
    stopColor: "#3D6AB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4401,
    stopColor: "#3983C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#3795D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8602,
    stopColor: "#37A0DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37A3DC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.93f1db027a240a91833cffea81bf8ec3.svg";
export { ForwardRef as ReactComponent };